import { Component, computed, inject, signal } from '@angular/core';
import { IWizardStepComponent } from '@mwe/models';
import { UiComponentsModule } from '@mwe/ui/components';
import { TopPageComponent } from '@shared-ikp/layout/top-page/top-page.component';
import { Router } from '@angular/router';
import { getCustomerRegistrationUrl, ROUTE_COMPANY_SELECT, ROUTE_HOME } from '../../../app.constants';
import { CustomerRegistrationService } from '../../../service/customer-registration/customer-registration.service';

@Component({
  selector: 'ikp-berater-thankyou',
  templateUrl: './thankyou.component.html',
  standalone: true,
  imports: [UiComponentsModule, TopPageComponent],
})
export class ThankyouComponent implements IWizardStepComponent {
  private router = inject(Router);
  private registrationService = inject(CustomerRegistrationService);

  errorHappened = computed(() => this.registrationService.isRegistrationError());
  isLoading = signal(false);

  handleRequest(): void {
    this.registrationService.isRegistrationError.set(false);
    this.isLoading.set(true);
    this.registrationService.createCustomer().finally(() => {
      this.isLoading.set(false);
    });
  }

  validate(): boolean {
    return true;
  }

  hasAllNeededData(): boolean {
    return (
      this.registrationService.registrationModel().companies.length > 0 &&
      this.registrationService.registrationModel().berater !== null &&
      this.registrationService.registrationModel().email !== ''
    );
  }

  submit(): Promise<void> {
    return Promise.resolve(undefined);
  }

  navigateToHome(): void {
    this.registrationService.clear();
    this.router.navigate([ROUTE_HOME]);
  }

  navigateToRegisterAccount(): void {
    this.registrationService.clear();
    this.registrationService.preSelectedGpNr.set(null);
    this.router.navigate([getCustomerRegistrationUrl(ROUTE_COMPANY_SELECT)]);
  }
}
